<template>
	<div class="supplier-wallet">
		<div class="container">
			<!-- Header -->
			<div class="page-header flex-center">
				<h1 class="page-title">{{ title }}</h1>
				<div class="page-header-right text-right ml-a">
				</div>
			</div>
			<div class="page-content">
				<!-- Table Menu -->
				<div class="table-list-menu">
					<div class="row">
						<div class="col-sm-3">
							<!-- Search Owner -->
							<multiselect v-model="selectedOwner"
								:show-labels="false"
								track-by="_id"
								label="label"
								:placeholder="searchPlaceholder"
								:options=optionOwner
								:loading="isSearchingOwner"
								@search-change="fetchDataOwner"
								>
								<span slot="noResult">
									No options matching the query
								</span>
								<span slot="noOptions">
									No options available
								</span>
							</multiselect>
						</div>
						<div class="col-sm-9">
							<div class="table-filters d-flex align-items-center justify-content-end ml-a">
								<!-- Clear Filter -->
								<button type="button" class="btn btn-plain btn-sm" @click="clearFilter" v-if="isFilterOn">
									{{ $t('Clear Filter') }}
								</button>
								<!-- Filter -->
								<button type="button" class="filter-toggle btn btn-light btn-sm btn-icon"
									@click="syncData"
									:class="{ 'is-loading': isSynchronizing }">
									<i class="material-icons mr-1">sync</i>Sync Data
								</button>
								<button
									@click="exportData"
									type="button"
									class="btn btn-sm btn-primary"
									:class="{ 'is-loading': isExporting }"
									:disabled="isDisabled"
									v-tooltip="{ content: isDisabled ? 'Sync Data sebelum Export' : '' }"
									>
									<i class="material-icons">save_alt</i>
									<span class="mr-2">{{ $t('Export') }}</span>
								</button>
							</div>
						</div>
					</div>
					<div class="lasy-sync text-right text-primary">
						Last Sync : {{ last_sync }}
					</div>
				</div>
				<div class="user-wallet-list table-responsive">
					<table class="user-wallet-list-table table table-primary table-striped">
						<thead>
							<tr>
								<th width="10%" class="text-left">
									ID {{ ownerLabel }}
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('name')"
									@click="changeSorting('name')">
									{{ ownerLabel }}
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('bank_accounts.label')"
									@click="changeSorting('bank_accounts.label')">
									No. Rekening
								</th>
								<th width="10%" class="th-sort text-left" :class="sortClass('wallet.balance')"
								@click="changeSorting('wallet.balance')">
									Total Kredit
								</th>
								<th width="10%" class="th-sort text-left">
									Action
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in items" :key="index">
								<td>
									<div class="row">
										<div class="col-md-9">
												{{ item._id }}
										</div>
										<div class="col-md-3">
											<span @click="copyId(item._id)" role="button">
												<i class="bi bi-front text-primary"></i>
											</span>
										</div>
									</div>
								</td>
								<td>
									<div class="name">
										{{ item.name}}
									</div>
									<div class="email">
										{{ item.email}}
									</div>
								</td>
								<td>
									<div class="row">
										<div class="col-md-8">
											{{ getFirstBankAccount(item) }}
										</div>
										<div class="col-md-4">
											<span role="button" class="mx-2" @click="copyBank(item.bank_accounts[0])" v-if="isHaveBankAccount(item)">
												<i class="bi bi-front text-primary"></i>
											</span>
										</div>
									</div>
									<div class="more-account text-primary" role="button" @click="showBankDetail(item)">
										{{ getMoreAccount(item) }}
									</div>
								</td>
								<td class="" v-tooltip.left="`Last Sync : ${getLastSync(item)}`">
									{{ getWallet(item) }}
								</td>
								<td class="" v-tooltip.left="`Last Sync : ${getLastSync(item)}`">
									<router-link :to="creditDetailRoute(item.email)">
									<button class="btn btn-sm btn-default">Credit Detail</button>
								</router-link>
								</td>
							</tr>
						</tbody>
					</table>
					<div class="table-fetch-status" v-if="isFetching">
						<div class="is-loading large dark m-auto"></div>
					</div>
					<!-- Empty -->
					<div class="list-empty" v-if="items.length === 0 && isFetching === false">
						<i class="material-icons mr-2">error_outline</i>
						<span v-if="keyword === ''">There is no Wallet Found yet.</span>
						<span v-else>No Wallet was found</span>
					</div>
				</div>
			</div>
		</div>
		<!-- MODAL DETAIL -->
		<modal :size="'large'" v-if="isShowDetail" @close="isShowDetail = false">
			<div slot="header">
				<h3>Rekening {{ ownerLabel }}</h3>
			</div>
			<div slot="body">
				<div class="row">
					<div class="col-md-4 mt-3" v-for="(item) in this.selectedData.bank_accounts" :key="item.account_number">
						<div class="row align-items-center card-account h-100">
							<div class="col-md-10">
								{{ getBankAccount(item) }}
							</div>
							<div class="col-md-2 d-flex align-items-center justify-content-center" @click="copyBank(item)" role="button">
								<i class="bi bi-front text-primary"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	duplicateVar,
	formatMoney,
	jsonPretty,
	formatDate,
	copyToClipboard,
	downloadFile,
} from '@/lib/helper';
import walletApi from '@/api/wallet';
import Modal from '@/components/Modal.vue';
import adminApi from '@/api/admin';

export default {
	name: 'AdminWallet',
	components: {
		Modal,
	},
	props: {
		ownerType: {
			type: String,
			default: 'supplier',
			validator: value => ['supplier', 'dropshipper'].includes(value),
		},
	},
	data() {
		return {
			limit: 25,
			page: 1,
			sort_by: 'wallet.balance',
			sort: 'desc',
			isFetching: false,
			isShowDetail: false,
			isSearchingOwner: false,
			isSynchronizing: false,
			isExporting: false,
			items: [],
			selectedData: {},
			selectedOwner: null,
			optionOwner: [],
			last_sync: null,
			isDisabled: true,
		};
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
			filterDatePresets: 'filterDatePresets',
		}),
		title() {
			return this.ownerType === 'supplier' ? 'Supplier Wallet' : 'Seller Wallet';
		},
		ownerLabel() {
			return this.ownerType === 'supplier' ? 'Supplier' : 'Seller';
		},
		searchPlaceholder() {
			return `id/email/nama ${this.ownerType === 'supplier' ? 'supplier' : 'dropshipper'}`;
		},
		creditDetailBasePath() {
			return this.ownerType === 'supplier' ? '/admin/supplier-wallet/credit-detail' : '/admin/dropshipper-wallet/credit-detail';
		},
		isFilterOn() {
			return this.selectedOwner !== null;
		},
	},
	methods: {
		formatMoney,
		jsonPretty,
		copyToClipboard,
		creditDetailRoute(email) {
			return `${this.creditDetailBasePath}?user_email=${email}`;
		},
		exportData() {
			this.isExporting = true;
			const params = this.getFetchParams();

			const callback = (response) => {
				this.isExporting = false;
				const url = response.data;
				downloadFile(url);
				this.isDisabled = true;
			};
			const errorCallback = () => {
				this.isExporting = false;
			};

			walletApi.exportOwnerWallet(params, callback, errorCallback);
		},
		lastSyncHeader() {
			const user = duplicateVar(this.filterObjectsWithProperties(this.items)[0]);
			const wallet = duplicateVar(user.wallet);
			if (this.last_sync == null) {
				this.last_sync = formatDate(this.moment, wallet.last_sync, 'DD-MM-YYYY hh:mm:ss');
			}
		},
		isHaveBankAccount(item) {
			return item?.bank_accounts?.length > 0 ?? false;
		},
		showBankDetail(item) {
			this.isShowDetail = true;
			this.selectedData = item;
		},
		getMoreAccount(item) {
			if (item?.bank_accounts?.length > 1) {
				return `+${item?.bank_accounts?.length - 1} lainnya`;
			}
			return '';
		},
		copyBank(item) {
			const bank = item.account_number;
			copyToClipboard(bank);
			this.$notify({
				group: 'app',
				title: 'Account Number Copied',
				text: bank,
				type: 'success',
			});
		},
		copyId(item) {
			copyToClipboard(item);
			this.$notify({
				group: 'app',
				title: 'ID Copied',
				text: item,
				type: 'success',
			});
		},
		resetItems() {
			this.items = [];
			this.page = 1;
		},
		filterObjectsWithProperties(array) {
			const objWithWallet = array.filter(item => 'wallet' in item);
			return objWithWallet;
		},
		getWallet(item) {
			return formatMoney(item?.wallet?.balance ?? 0);
		},
		getLastSync(item) {
			return item?.wallet?.last_sync ? formatDate(this.moment, item?.wallet?.last_sync, 'DD-MM-YYYY hh:mm:ss') : this.last_sync;
		},
		syncData() {
			this.last_sync = null;
			this.isSynchronizing = true;
			const callback = () => {
				this.isSynchronizing = false;
				this.fetchItems(true);
				this.$notify({
					group: 'app',
					title: 'Sync Successfully',
					type: 'success',
				});
				this.isDisabled = false;
			};

			const errorCallback = () => {
				this.isSynchronizing = false;
			};

			const params = { owner_type: this.ownerType };

			walletApi.syncOwnerWalletData(params, callback, errorCallback);
		},
		fetchDataOwner(query) {
			this.isSearchingOwner = true;

			const params = {
				keyword: query,
				role: 'owner',
				owner_type: this.ownerType,
			};

			const callback = (response) => {
				this.optionOwner = response.data;
				this.isSearchingOwner = false;
			};
			const errorCallback = () => {
				this.isSearchingOwner = false;
			};

			this.ooDelay(() => {
				if (query !== '') {
					adminApi.searchUser(params, callback, errorCallback);
				}
			}, 1000);
		},
		getFirstBankAccount(item) {
			return item?.bank_accounts?.length > 0 ? `${item.bank_accounts[0].account_name} - ${item.bank_accounts[0].account_number} ${item.bank_accounts[0].label}` : '-' ?? '-';
		},
		getBankAccount(item) {
			return `${item.account_name} - ${item.account_number} ${item.label}` ?? '-';
		},
		formatDate,
		getFetchParams() {
			const params = {
				owner_type: this.ownerType,
				limit: this.limit,
				sort_by: this.sort_by,
				sort: this.sort,
				page: this.page,
			};

			if (this.selectedOwner) {
				params.supplier_id = this.selectedOwner._id;
			}

			return params;
		},
		fetchItems(reset = true) {
			this.isFetching = true;
			if (reset) {
				this.resetItems();
			}

			const params = this.getFetchParams();

			const callback = (response) => {
				this.isFetching = false;
				this.isSearchingOwner = false;
				const items = response.data;
				if (items.length > 0) {
					this.page++;
					this.items = this.items.concat(items);
				} else {
					this.isAll = true;
				}
				this.lastSyncHeader();
			};

			const errorCallback = () => {
				this.isFetching = false;
			};

			walletApi.getOwnerWalletList(params, callback, errorCallback);
		},
		handleScroll() {
			const pageHeight = document.documentElement.offsetHeight;
			const windowHeight = window.innerHeight;
			const scrollPosition = window.scrollY;
			const offset = 50;
			const isOnBottom = pageHeight - offset <= windowHeight + scrollPosition;
			if (isOnBottom) {
				if (!this.isFetching && !this.isAll) {
					this.fetchItems(false);
				}
			}
		},
		changeSorting(key) {
			const isSame = this.sort_by === key;
			this.sort_by = key;
			const sort = isSame && this.sort === 'asc' ? 'desc' : 'asc';
			this.sort = sort;
			this.fetchItems(true);
		},
		sortClass(key) {
			const sameKey = this.sort_by === key;
			const className = sameKey ? `th-sort-${this.sort}` : '';
			return className;
		},
		applyFilter() {
			this.fetchItems(true);
		},
		resetFilter() {
			this.selectedOwner = null;
		},
		clearFilter() {
			this.$router.replace({ query: null });
			this.resetFilter();
			this.applyFilter();
		},
	},
	watch: {
		selectedOwner() {
			if (this.selectedOwner) {
				this.fetchItems(true);
			}
		},
	},
	created() {
		this.fetchItems();
		window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="scss" scoped>

.user-select-none {
	cursor: default !important;
}

.email {
	color: #676C78;
}

.overflow-auto {
	overflow: auto;
}
.overflow-x-auto {
	overflow-x: auto;
}


.card-account {
	border: 1px solid #80848E;
	border-radius: 8px;
	margin: 10px 0px;
}
</style>
